import React from 'react';

const BookmarkIcon = ({ width = 30, height = 37.5, color = 'white', filled = false, ...props }) => (
  <svg width={width} height={height} viewBox={`0 0 32 32`} fill="white" {...props}>
    {!filled && (
      <path
        d="M8.01318 2.66663C6.55258 2.66663 5.34652 3.87009 5.34652 5.33069L5.3335 29.3333L16.0002 25.3333L26.6668 29.3333V27.4088V5.33329C26.6668 3.87588 25.4576 2.66663 24.0002 2.66663H8.01318ZM8.01318 5.33329H24.0002V25.4843L16.0002 22.4843L8.00277 25.4843L8.01318 5.33329Z"
        fill={color}
      />
    )}
    {filled && (
      <path
        d="M8.01318 2.66663C6.55258 2.66663 5.34652 3.87009 5.34652 5.33069L5.3335 29.3333L16.0002 25.3333L26.6668 29.3333V27.4088V5.33329C26.6668 3.87588 25.4576 2.66663 24.0002 2.66663H8.01318ZM8.01318"
        fill={color}
      />
    )}
  </svg>
);

export default BookmarkIcon;
